<template>
  <div>
    <h5 class="text-main-gradient-secondary"><span class="material-icons ">sensors</span> Current sensors</h5>
    <p>Overview of total registered sensors</p>
    <apexchart ref="chart" type="pie" :options="chartOptions" :series="series" />
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import axios from "axios";
var config = require("@/config/api.json");
const API = config.api;

export default {
  components: {
    apexchart: VueApexCharts,
  },
  data() {
    return {
      isLightMode: true,
      currentSensors: [],
      series: [1,2,3,4,5], // Inicialmente vacío, se llenará con sensor_count
      chartOptions: {
        chart: {
          width: 380,
          type: "pie",
        },
        labels: [], // Inicialmente vacío, se llenará con sensor_type
        dataLabels: {
          enabled: true,
          formatter: function (val, opts) {
            return opts.w.config.series[opts.seriesIndex];
          },
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 300,
              },
              legend: {
                position: "bottom",
              },
            },
          },
        ],
      },
    };
  },
  // watch: {
  //   isLightMode(newValue) {
  //     console.log("watch isLightMode", newValue);
  //     this.applyTheme();
  //   },
  // },
  created() {
    this.$eventBus.$on("lightModeChanged", (newValue) => {
      this.isLightMode = newValue;
      console.log("Light mode changed in Total-sensors.vue:", newValue);
      this.applyTheme();
    });
  },
  mounted() {
    this.managerCurrentSensors();
    this.applyTheme();
    // setInterval(this.applyTheme, 1000);
  },
  methods: {
    applyTheme() {
    this.isLightTheme = localStorage.getItem('light') === 'true';
    // const isLightTheme = localStorage.getItem('light') !== 'false';
    console.log("isLightTheme", this.isLightTheme);
    // this.chartOptions.dataLabels.style = {
    //   colors: [isLightTheme ? '#FFF' : '#000'] // Negro para claro, blanco para oscuro
    // };
    this.chartOptions.legend = {
      labels: {
        colors: this.isLightTheme ? '#000' : '#FFF' // Cambia el color de las etiquetas de la leyenda
      }
    };
    this.$refs.chart.updateOptions({
          dataLabels: this.chartOptions.dataLabels,
          legend: this.chartOptions.legend
        });
  },
    async managerCurrentSensors() {
      try {
        const response = await axios.get(`${API}/manager-get-sensors-chart`);
        this.currentSensors = response.data;
        const labels = [];
        const series = [];
        this.currentSensors.forEach(sensor => {
          labels.push(sensor.sensor_type);
          series.push(sensor.sensor_count);
        });
        this.$refs.chart.updateOptions({
          labels: labels,
          series: series,
          dataLabels: this.chartOptions.dataLabels,
          legend: this.chartOptions.legend
        });
      } catch (error) {
        this.notify('error', 'There are no sensors to show');
      }
    }
  }
};
</script>